// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".docs-controls {\n  display: flex;\n  justify-content: space-between;\n  text-align: left;\n}\n", "",{"version":3,"sources":["docs-container.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB","file":"docs-container.css","sourcesContent":[".docs-controls {\n  display: flex;\n  justify-content: space-between;\n  text-align: left;\n}\n"]}]);
// Exports
module.exports = exports;
